import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import getRouteByNameAndLanguage from 'getRouteByName';
import JobItemMetadata from '@Components/JobItemMetadata';
import Icon from '@UI/Icon';
import { CustomDateFormat } from 'DateFormatter';
import SaveJob from '@Components/SaveJob';
import textTransform from 'textTransform';

function JobCard({
  intl, jobData, config, saveJobModalCb, favoriteJobs, jobListingsSettings,
}) {
  const cardRef = useRef();
  const {
    BlueXJobData,
    JobDates,
    JobUrl,
    JobId,
    infoIcon,
    closeIcon,
  } = jobData;

  const title = BlueXJobData.Title;
  const description = BlueXJobData.Description;
  const { additional_card_settings } = config;

  const favoriteIconProps = (additional_card_settings || {}).favorite_icon_attributes || {};
  const baseUrl = getRouteByNameAndLanguage('salaryChecker', intl.locale).url.replace(process.env.REACT_APP_JOB_DETAILS_ROUTE_WILDCARD, '');

  const formatDate = () => intl.formatMessage(
    { id: 'JobDetails.OpenDate.DateFormat' },
    { date: CustomDateFormat(JobDates.DateCreated) },
  );

  const cleanHTML = (string) => string.replace(/<[^>]+>/g, '').substring(0, 300);

  useEffect(() => {
    // Import card component from the Orbit.
    /* eslint-disable */
    if (cardRef.current) {
      const { Card } = require('@ffw/randstad-local-orbit/js/components/card');
      new Card(cardRef.current);
    }
    /* eslint-enable */
  }, []);

  useEffect(() => {
    if (cardRef.current.classList.contains('cards__item--backside-active')) {
      cardRef.current.querySelector('[data-rs-card-hide-backside]').click();
    }
  }, []);

  return (
    <li
      className="cards__item bg-variant-white"
      data-rs-card
      data-rs-carousel-card
      ref={cardRef}
    >
      <div className="cards__header">
        <div className="cards__logo-title-container">
          <h3 className="cards__title">
            <Link
              to={JobUrl}
              target="_blank"
              className="cards__link"
              // Legacy Job app dataLayer call.
              // eslint-disable-next-line no-eval
              onMouseDown={() => eval(jobData.dataLayerJobClick)}
            >
              { textTransform(title, true) }
              <span className="make-entire-card-clickable" />
            </Link>
          </h3>
        </div>
        {additional_card_settings && Number(additional_card_settings.favorite_icon) === 1
          && (
          <SaveJob
            saveJobModalCb={saveJobModalCb}
            jobData={jobData}
            baseUrl={baseUrl}
            size="l"
            favoriteIconProps={favoriteIconProps}
            favoriteJobs={favoriteJobs}
          />
          )}
      </div>

      <JobItemMetadata jobData={jobData} config={config} jobListingsSettings={jobListingsSettings} />
      {/* Render description from the BlueXJob */}
      {/* eslint-disable */}
      <div className="cards__description" dangerouslySetInnerHTML={{ __html: description }} />
      {/* eslint-enable */}

      <div className="cards__footer">
        <div className="cards__time-info">
          <span className="cards__date text--alternative">
            { formatDate() }
          </span>
        </div>
        <div
          className="cards__info-wrapper"
          data-rs-card-show-backside
          {...infoIcon}
        >
          <span className="cards__info-button text--alternative">
            <span className="icon icon--inline">
              <Icon type="info" />
            </span>
          </span>
        </div>
      </div>

      <div className="cards__backside-card">
        <div className="cards__backside-description">
          {cleanHTML(description)}
        </div>

        <div className="cards__backside-footer">
          <Link
            to={JobUrl}
            target="_blank"
            data-jobid={JobId}
            className="cards__backside-footer--horizontal cards__backside-footer--job-link"
          >
            <span className="icon icon--inline">
              <Icon type="eye" />
            </span>
            { intl.formatMessage({ id: 'JobDetails.ViewJob' }) }
          </Link>
          <div
            data-rs-card-hide-backside=""
            className="cards__backside-footer--horizontal cards__backside-footer--close-backside"
            tabIndex="-1"
            role="button"
            {...closeIcon}
          >
            <span className="icon icon--inline">
              <Icon type="close" />
            </span>
            <span className="button-text hidden--visually">{ intl.formatMessage({ id: 'Close' }) }</span>
          </div>
        </div>
      </div>
    </li>
  );
}

export default injectIntl(JobCard);
